<ng-template #defaultIndicatorTemplate>
  <span
    class="ant-spin-dot"
    [class.ant-spin-dot-spin]="resultSpinning$|async">
    <i></i><i></i><i></i><i></i>
  </span>
</ng-template>
<div [class.ant-spin-nested-loading]="isNested">
  <div [hidden]="!(resultSpinning$|async)">
    <div
      class="ant-spin"
      [class.ant-spin-spinning]="resultSpinning$|async"
      [class.ant-spin-lg]="dwSize=='large'"
      [class.ant-spin-sm]="dwSize=='small'"
      [class.ant-spin-show-text]="dwTip">
      <ng-template [ngTemplateOutlet]="dwIndicator||defaultIndicatorTemplate"></ng-template>
      <div class="ant-spin-text" *ngIf="dwTip">{{ dwTip }}</div>
    </div>
  </div>
  <div
    #containerElement
    class="ant-spin-container"
    [class.ant-spin-blur]="resultSpinning$|async"
    [hidden]="!isNested"
    (cdkObserveContent)="checkNested()">
    <ng-content></ng-content>
  </div>
</div>